<!-- Main Container -->
<main id="main-container">
  
  <!-- Page Content -->
  <div id="changeContentContainerClasses" [ngClass]="layoutClasses">

    <!-- the main router outlet for the whole app -->
    <router-outlet></router-outlet>

  </div>
  <!-- END Page Content -->
</main>
<!-- END Main Container -->



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/container/container.component.html